<template>
</template>

<script>
import axios from 'axios';
import { currentProfileCache } from '@/modules/utils/currentProfileCache.js';
import { clearCheckoutSessionStorage } from '@/utils.js';
  
  export default {
    props: {
      isUserLoggedIn: {
        type: Boolean, 
        default: false
      },
      userDataUrl: {
        type: String,
        default: '/umbraco/surface/authenticationapi/currentprofile'
      },
      pageData: {
        type: String,
        default: ''
      },
      tourData: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        userData: null
      };
    },
    mounted: async function() {
      if(this.isUserLoggedIn){
        await this.fetchUserData(this.userDataUrl);
      }
      GTM.pageViewEvent(this.pageData, this.userData);
      if(this.tourData !== ''){
        const tourData = JSON.parse(this.tourData);
        GTM.viewItem(tourData);
      }
    },
    methods: {
      async fetchUserData(url) {
        try {
          // Check for cached profile data
          const cachedProfile = currentProfileCache.get();
          
          if (cachedProfile) {
            // Use cached profile data
            this.userData = cachedProfile;
            return;
          }
          
          // If no cached data, fetch from API
          const response = await axios.get(url);
          this.userData = response.data;
          
          // Cache the profile data
          currentProfileCache.set(response.data);
        } catch (error) {
          if (error.response && [400, 401, 403].includes(error.response.status)) {
            // Session expired or unauthorized, call logout
            try {
              await axios.get('/umbraco/surface/authenticationapi/Logout');
              clearCheckoutSessionStorage();
            } catch (logoutError) {
              console.warn('Failed to logout:', logoutError);
            }
          } else {
            console.warn('Failed to fetch user profile:', error);
          }
        }
      }
    },
  };
</script>
